import axios from 'axios';
const PREFIJO="/api/Token";
const PREFIJO2="/api/Lgn/";
// import qs from 'qs';
import constantes from "../constantes";
import store from "../store";
import moment from "moment";

class AuthService {

    olvidoPws(formulario){
        const data = {
            dt1: formulario.dt1,
        };
        return axios.post(`${PREFIJO2}VmLvdClv`,data);
    }


    validarSMS(id,codigo){
        const data = {
            id: id,
            dt1: codigo,
        };
        return axios.post(`${PREFIJO2}VmVrf`,data)
            .then(r=>r.data)
            .then(data=>{
                return data;
            });
    }

    renovarToken(){
        const data = {
            dt1: store.getters.getUsuario.dt100,
        };
        return axios.post(`${PREFIJO}/VmUpTkn`,data)
            .then(response=>response.data)
            .then(data=>{
                return data;
            });
    }

    reenviarCode(id){
        const data = {
            id: id,
        };
        return axios.post(`${PREFIJO2}VmGnrC`,data);
    }

    validarDatos(formulario){
        const data = {
            dt1: formulario.ci,
            dt6: formulario.email,
        };
        return axios.post(`${PREFIJO2}VmVrfMd`,data);
    }

    login(formulario) {
        const data = {
            dt99: formulario.dt1,
            dt100: formulario.dt2,
        };
        return axios.post(`${PREFIJO}`,data)
            .then(response=>{
                return response
            });
    }
    register(formulario) {
        const data = {
            dt1:formulario.ci,//identificacióncliente
            dt2:formulario.password,//clave
            dt3:formulario.nombres,//Nombre
            dt4:formulario.apellidos,//Apellido
            dt5:formulario.telefono,//Celular
            dt6:formulario.email,//Correo
            dt16:process.env.VUE_APP_PAIS_NAME,
            dt20:formulario.token,//recaptcha
            ndt2:formulario.genero.id,//IdGenero
            ddt1:moment(formulario.fecha,"DD/MM/YYYY").toISOString(),//FechaNacimiento
            ndt3:store.getters.getPasos[3].agencia.id,//idAgencia
            ndt1 :constantes.Constantes.enumeraciones.idApp
        };
        return axios.post(`${PREFIJO2}VmCr`,data);
    }
    logout(formulario) {
        const dto = {
            dt99:formulario.dt1 ? formulario.dt1 : store.getters.getDni,
        };
        return axios.post(`${PREFIJO2}VmLgOut`,dto)
            .then(response=>response.data)
            .then(data=>{
                return data;
            });
    }
}
export default new AuthService();
